import { useId } from "react";
import { tv } from "tailwind-variants";

import { Heading } from "@/ui";

const stepNumberVariants = tv({
  base: "flex size-7 shrink-0 items-center justify-center rounded-full border font-semibold",
  variants: {
    filled: {
      true: "border-transparent bg-surface-inverted text-content-on-inverted",
      false: "border-line bg-surface text-content",
    },
  },
});

const STEPS = [
  {
    title: "Secure checkout",
    description: "Address and payment on the next screen. Nothing is charged until you confirm.",
  },
  {
    title: "Your first shipment",
    description: "Discreet packaging, free shipping.",
  },
  {
    title: "A check-in after your first week",
    description: "Your care team tunes the plan with you. Message or call anytime.",
  },
];

export const CareplanCartWhatHappensNext = () => {
  const headingId = useId();

  return (
    <section
      aria-labelledby={headingId}
      className="flex flex-col gap-4 rounded-xl bg-canvas p-5 text-base"
    >
      <Heading id={headingId} level={4}>
        What happens next
      </Heading>

      <ol className="flex flex-col" role="list">
        {STEPS.map((step, index) => {
          const isFirstStep = index === 0;

          return (
            <li
              className="relative flex gap-3 pb-4 after:absolute after:top-7 after:bottom-0 after:left-3.5 after:w-px after:-translate-x-1/2 after:bg-line last:pb-0 last:after:hidden"
              key={step.title}
            >
              <span aria-hidden="true" className={stepNumberVariants({ filled: isFirstStep })}>
                {index + 1}
              </span>

              <div className="flex flex-col">
                <p className="font-semibold text-content">{step.title}</p>
                <p className="text-content-secondary">{step.description}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
